import React, { useState } from "react";
import QRCode from "react-qr-code";
import Button from "../global/Button";
import { useRefreshPaymentLinkMutation } from "../../lib/redux/services/sections/Booking";
import { toast } from "react-toastify";
import { toastMessage } from "../../utils/utils";
import { useGetDictionary } from "../../hooks/useGetDictionary";
type Props = {
  title:string
  link:string
  toggleModal?:()=>void
}

const QRModal = ({ toggleModal, link, title }: Props) => {
  const { shared, coaches, Academy, events, inputs } = useGetDictionary();
  const [linkState, setlinkState] = useState(link);
  const [refreshPaymentLink] = useRefreshPaymentLinkMutation();

  const refreshPaymentLinkHandler = async () => {
    try {
      const data = await toast.promise(
        refreshPaymentLink({ link }).unwrap(),
        toastMessage()
      );
      console.log(data.data);
      setlinkState(data?.data);
    } catch (error) {}
  };
  return (
    <div className="flex flex-col gap-4 px-6 py-5">
      <div className="flex flex-col justify-center items-center gap-4 text-center ">
        <QRCode value={linkState} size={250} />

        <h2 className="text-primary dark:text-white">
          {Academy.congratulations}
        </h2>
        <p className=" relative text-lg font-normal text-[#1E1850] text-center break-words leading-relaxed whitespace-pre-wrap w-[80%] mx-auto  ">
          {title}
        </p>
      </div>
      <div className="flex flex-col gap-4 w-full px-10">
        <Button
          customeStyle="text-red-500 hover:border border-primaryRed border hover:bg-primaryRed hover:text-white p-2 px-2 rounded-full w-full transition duration-300 text-lg py-3"
          text={"close"}
          type="button"
          width="w-full"
          onClick={(e) => {
            toggleModal?.();
          }}
        />
      </div>
    </div>

    // <div className="py-5 flex flex-col justify-center items-center gap-5">
    //   <h1 className="text-xl">{title}</h1>
    //   <QRCode value={linkState} size={250} />
    //   <div className="flex flex-col gap-4 w-full px-10">
    //     <Button
    //       customeStyle="bg-primary text-white p-2 px-2 rounded-full w-full  transition duration-300 text-lg py-4"
    //       text={"Generate new link"}
    //       type="button"
    //       width="w-full"
    //       onClick={(e) => {
    //         refreshPaymentLinkHandler();
    //       }}
    //     />
    //     <Button
    //       customeStyle="text-red-500 hover:border border-primaryRed border hover:bg-primaryRed hover:text-white p-2 px-2 rounded-full w-full transition duration-300 text-lg py-3"
    //       text={"close"}
    //       type="button"
    //       width="w-full"
    //       onClick={(e) => {
    //         toggleModal();
    //       }}
    //     />
    //   </div>
    // </div>
  );
};

export default QRModal;
